import React from 'react'
import PropTypes from 'prop-types'

import CardContainerSkeletonMobile from 'assets/img/card_container_skeleton_mobile.png'
import CardContainerSkeleton from 'assets/img/card_container_skeleton.png'
import CardSkeleton from 'assets/svg/card_skeleton.svg'

import {
    LoadingProductContainerMobile,
    LoadingProductContainer,
    LoadingProductCard,
    Loadings,
    LoadingSlider
} from './LoadingProductsSkeleton.style.jsx'

const LoadingProductsSkeleton = ({ active, mobile }) => (
    <Loadings>
        {mobile ? (
            <LoadingProductContainerMobile
                src={CardContainerSkeletonMobile}
                alt="loading skeleton mobile"
                $active={active}
            />
        ) : (
            <LoadingProductContainer
                src={CardContainerSkeleton}
                alt="loading skeleton"
                $active={active}
            />
        )}
        <LoadingSlider>
            {[0, 1, 2, 3].map((i) => (
                <LoadingProductCard
                    key={i}
                    src={CardSkeleton}
                    alt="loading skeleton"
                    $active={active}
                />
            ))}
        </LoadingSlider>
    </Loadings>
)

LoadingProductsSkeleton.propTypes = {
    active: PropTypes.bool.isRequired
}

export default LoadingProductsSkeleton
